// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HeaderWhite_root__KaP3l .HeaderWhite_navbar__CGAky {
  --bs-navbar-padding-x: 0;
  --bs-navbar-padding-y: 0;
}
.HeaderWhite_root__KaP3l .HeaderWhite_navbar__CGAky .HeaderWhite_navbarBrand__QEM0w {
  padding: 0;
}
.HeaderWhite_root__KaP3l .HeaderWhite_navbar__CGAky .HeaderWhite_navbarBrand__QEM0w .HeaderWhite_LogoTitleBlock__AyUw1 img {
  width: 120px;
}
.HeaderWhite_root__KaP3l .HeaderWhite_navbar__CGAky .HeaderWhite_navbarBrand__QEM0w .HeaderWhite_LogoTitleBlock__AyUw1 p {
  margin-left: 20px;
  font-size: 16px;
  color: #fff;
}
.HeaderWhite_root__KaP3l .HeaderWhite_navbar__CGAky .HeaderWhite_nav__RYfpR {
  align-items: center;
  --bs-nav-link-color: #fff;
  --bs-nav-link-hover-color: #d71921;
  --bs-navbar-active-color: #d71921;
}
.HeaderWhite_root__KaP3l .HeaderWhite_navbar__CGAky .HeaderWhite_nav__RYfpR a::after {
  display: none;
}
.HeaderWhite_root__KaP3l .HeaderWhite_navbar__CGAky .HeaderWhite_dropdown__yPICW .HeaderWhite_dropdownBtn__yQGgp {
  --bs-btn-bg: #1b51e3;
  --bs-btn-border-color: none;
  --bs-btn-hover-border-color: none;
  --bs-btn-active-border-color: none;
  --bs-btn-disabled-border-color: none;
  --bs-btn-border-radius: 20px;
}
.HeaderWhite_root__KaP3l .HeaderWhite_navbar__CGAky .HeaderWhite_dropdown__yPICW .HeaderWhite_dropdownMenu__RknK0 {
  --bs-dropdown-min-width: 0;
  --bs-dropdown-padding-x: 0;
  --bs-dropdown-padding-y: 0;
  --bs-dropdown-border-radius: 20px;
}
.HeaderWhite_root__KaP3l .HeaderWhite_navbar__CGAky .HeaderWhite_dropdown__yPICW .HeaderWhite_dropdownMenu__RknK0 .HeaderWhite_dropdownItem__psJHU:hover {
  border-radius: 20px;
}
.HeaderWhite_root__KaP3l .HeaderWhite_navbar__CGAky .HeaderWhite_adaptiveDropdown__zOXia {
  display: none;
}

@media (max-width: 991px) {
  .HeaderWhite_root__KaP3l .HeaderWhite_navbar__CGAky .HeaderWhite_dropdown__yPICW {
    display: none;
  }
  .HeaderWhite_root__KaP3l .HeaderWhite_navbar__CGAky .HeaderWhite_adaptiveBtn__3Yhjm {
    display: flex;
    align-items: center;
  }
  .HeaderWhite_root__KaP3l .HeaderWhite_navbar__CGAky .HeaderWhite_adaptiveBtn__3Yhjm .HeaderWhite_adaptiveDropdown__zOXia {
    display: block;
    margin-right: 10px;
  }
  .HeaderWhite_root__KaP3l .HeaderWhite_navbar__CGAky .HeaderWhite_adaptiveBtn__3Yhjm .HeaderWhite_adaptiveDropdown__zOXia .HeaderWhite_dropdownBtn__yQGgp {
    --bs-btn-bg: #1b51e3;
    --bs-btn-border-color: none;
    --bs-btn-hover-border-color: none;
    --bs-btn-active-border-color: none;
    --bs-btn-disabled-border-color: none;
    --bs-btn-border-radius: 20px;
  }
  .HeaderWhite_root__KaP3l .HeaderWhite_navbar__CGAky .HeaderWhite_adaptiveBtn__3Yhjm .HeaderWhite_adaptiveDropdown__zOXia .HeaderWhite_dropdownMenu__RknK0 {
    --bs-dropdown-min-width: 0;
    --bs-dropdown-padding-x: 0;
    --bs-dropdown-padding-y: 0;
    --bs-dropdown-border-radius: 20px;
  }
  .HeaderWhite_root__KaP3l .HeaderWhite_navbar__CGAky .HeaderWhite_adaptiveBtn__3Yhjm .HeaderWhite_adaptiveDropdown__zOXia .HeaderWhite_dropdownMenu__RknK0 .HeaderWhite_dropdownItem__psJHU:hover {
    border-radius: 20px;
  }
  .HeaderWhite_root__KaP3l .HeaderWhite_navbar__CGAky .HeaderWhite_adaptiveBtn__3Yhjm .HeaderWhite_toggleMenu__D8bwP {
    background: #fff;
  }
}
@media (max-width: 768px) {
  .HeaderWhite_root__KaP3l .HeaderWhite_navbar__CGAky .HeaderWhite_navbarBrand__QEM0w .HeaderWhite_LogoTitleBlock__AyUw1 img {
    width: 100px;
  }
  .HeaderWhite_root__KaP3l .HeaderWhite_navbar__CGAky .HeaderWhite_navbarBrand__QEM0w .HeaderWhite_LogoTitleBlock__AyUw1 p {
    font-size: 14px;
  }
  .HeaderWhite_root__KaP3l .HeaderWhite_nav__RYfpR {
    font-size: 14px;
  }
  .HeaderWhite_root__KaP3l .HeaderWhite_dropdown__yPICW .HeaderWhite_dropdownBtn__yQGgp {
    font-size: 14px;
  }
}
@media (max-width: 500px) {
  .HeaderWhite_root__KaP3l .HeaderWhite_navbar__CGAky .HeaderWhite_navbarBrand__QEM0w .HeaderWhite_LogoTitleBlock__AyUw1 img {
    width: 90px;
  }
  .HeaderWhite_root__KaP3l .HeaderWhite_navbar__CGAky .HeaderWhite_navbarBrand__QEM0w .HeaderWhite_LogoTitleBlock__AyUw1 p {
    font-size: 12px;
  }
  .HeaderWhite_root__KaP3l .HeaderWhite_navbar__CGAky .HeaderWhite_nav__RYfpR {
    font-size: 12px;
  }
  .HeaderWhite_root__KaP3l .HeaderWhite_navbar__CGAky .HeaderWhite_dropdown__yPICW .HeaderWhite_dropdownBtn__yQGgp {
    font-size: 12px;
  }
}
@media (max-width: 431px) {
  .HeaderWhite_root__KaP3l .HeaderWhite_navbar__CGAky .HeaderWhite_navbarBrand__QEM0w .HeaderWhite_LogoTitleBlock__AyUw1 p {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Header/HeaderWhite/HeaderWhite.module.scss"],"names":[],"mappings":"AACE;EACE,wBAAA;EACA,wBAAA;AAAJ;AAEI;EACE,UAAA;AAAN;AAGQ;EACE,YAAA;AADV;AAIQ;EACE,iBAAA;EACA,eAAA;EACA,WAAA;AAFV;AAOI;EACE,mBAAA;EACA,yBAAA;EACA,kCAAA;EACA,iCAAA;AALN;AAQQ;EACE,aAAA;AANV;AAYM;EACE,oBAAA;EACA,2BAAA;EACA,iCAAA;EACA,kCAAA;EACA,oCAAA;EACA,4BAAA;AAVR;AAaM;EACE,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,iCAAA;AAXR;AAcU;EACE,mBAAA;AAZZ;AAkBI;EACE,aAAA;AAhBN;;AAqBA;EAGM;IACE,aAAA;EApBN;EAuBI;IACE,aAAA;IACA,mBAAA;EArBN;EAuBM;IACE,cAAA;IACA,kBAAA;EArBR;EAuBQ;IACE,oBAAA;IACA,2BAAA;IACA,iCAAA;IACA,kCAAA;IACA,oCAAA;IACA,4BAAA;EArBV;EAwBQ;IACE,0BAAA;IACA,0BAAA;IACA,0BAAA;IACA,iCAAA;EAtBV;EAyBY;IACE,mBAAA;EAvBd;EA6BM;IACE,gBAAA;EA3BR;AACF;AAiCA;EAKU;IACE,YAAA;EAnCV;EAsCQ;IACE,eAAA;EApCV;EA0CE;IACE,eAAA;EAxCJ;EA4CI;IACE,eAAA;EA1CN;AACF;AA+CA;EAKU;IACE,WAAA;EAjDV;EAoDQ;IACE,eAAA;EAlDV;EAuDI;IACE,eAAA;EArDN;EAyDM;IACE,eAAA;EAvDR;AACF;AA6DA;EAKU;IACE,aAAA;EA/DV;AACF","sourcesContent":[".root {\n  .navbar {\n    --bs-navbar-padding-x: 0;\n    --bs-navbar-padding-y: 0;\n\n    .navbarBrand {\n      padding: 0;\n\n      .LogoTitleBlock {\n        img {\n          width: 120px;\n        }\n\n        p {\n          margin-left: 20px;\n          font-size: 16px;\n          color: #fff;\n        }\n      }\n    }\n\n    .nav {\n      align-items: center;\n      --bs-nav-link-color: #fff;\n      --bs-nav-link-hover-color: #d71921;\n      --bs-navbar-active-color: #d71921;\n\n      a {\n        &::after {\n          display: none;\n        }\n      }\n    }\n\n    .dropdown {\n      .dropdownBtn {\n        --bs-btn-bg: #1b51e3;\n        --bs-btn-border-color: none;\n        --bs-btn-hover-border-color: none;\n        --bs-btn-active-border-color: none;\n        --bs-btn-disabled-border-color: none;\n        --bs-btn-border-radius: 20px;\n      }\n\n      .dropdownMenu {\n        --bs-dropdown-min-width: 0;\n        --bs-dropdown-padding-x: 0;\n        --bs-dropdown-padding-y: 0;\n        --bs-dropdown-border-radius: 20px;\n\n        .dropdownItem {\n          &:hover {\n            border-radius: 20px;\n          }\n        }\n      }\n    }\n\n    .adaptiveDropdown {\n      display: none;\n    }\n  }\n}\n\n@media (max-width: 991px) {\n  .root {\n    .navbar {\n      .dropdown {\n        display: none;\n      }\n\n      .adaptiveBtn {\n        display: flex;\n        align-items: center;\n\n        .adaptiveDropdown {\n          display: block;\n          margin-right: 10px;\n\n          .dropdownBtn {\n            --bs-btn-bg: #1b51e3;\n            --bs-btn-border-color: none;\n            --bs-btn-hover-border-color: none;\n            --bs-btn-active-border-color: none;\n            --bs-btn-disabled-border-color: none;\n            --bs-btn-border-radius: 20px;\n          }\n\n          .dropdownMenu {\n            --bs-dropdown-min-width: 0;\n            --bs-dropdown-padding-x: 0;\n            --bs-dropdown-padding-y: 0;\n            --bs-dropdown-border-radius: 20px;\n\n            .dropdownItem {\n              &:hover {\n                border-radius: 20px;\n              }\n            }\n          }\n        }\n\n        .toggleMenu {\n          background: #fff;\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .root {\n    .navbar {\n      .navbarBrand {\n        .LogoTitleBlock {\n          img {\n            width: 100px;\n          }\n\n          p {\n            font-size: 14px;\n          }\n        }\n      }\n    }\n\n    .nav {\n      font-size: 14px;\n    }\n\n    .dropdown {\n      .dropdownBtn {\n        font-size: 14px;\n      }\n    }\n  }\n}\n\n@media (max-width: 500px) {\n  .root {\n    .navbar {\n      .navbarBrand {\n        .LogoTitleBlock {\n          img {\n            width: 90px;\n          }\n\n          p {\n            font-size: 12px;\n          }\n        }\n      }\n\n      .nav {\n        font-size: 12px;\n      }\n\n      .dropdown {\n        .dropdownBtn {\n          font-size: 12px;\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 431px) {\n  .root {\n    .navbar {\n      .navbarBrand {\n        .LogoTitleBlock {\n          p {\n            display: none;\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `HeaderWhite_root__KaP3l`,
	"navbar": `HeaderWhite_navbar__CGAky`,
	"navbarBrand": `HeaderWhite_navbarBrand__QEM0w`,
	"LogoTitleBlock": `HeaderWhite_LogoTitleBlock__AyUw1`,
	"nav": `HeaderWhite_nav__RYfpR`,
	"dropdown": `HeaderWhite_dropdown__yPICW`,
	"dropdownBtn": `HeaderWhite_dropdownBtn__yQGgp`,
	"dropdownMenu": `HeaderWhite_dropdownMenu__RknK0`,
	"dropdownItem": `HeaderWhite_dropdownItem__psJHU`,
	"adaptiveDropdown": `HeaderWhite_adaptiveDropdown__zOXia`,
	"adaptiveBtn": `HeaderWhite_adaptiveBtn__3Yhjm`,
	"toggleMenu": `HeaderWhite_toggleMenu__D8bwP`
};
export default ___CSS_LOADER_EXPORT___;
